import React, {Component} from 'react';
import InitialsIcon from '../components/InitialsIcon';

import ToolTip from 'react-portal-tooltip';
import {Popup} from 'semantic-ui-react';

import './AdminIcon.css';
import { Button } from '../components/FormUI';
import AccountService from '../api/services/AccountService';

export default class AdminIcon extends Component{
	constructor(props){
		super(props);
		this.account = new AccountService();

		this.state = {}
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick(){
		this.setState({isToolTipActive: true});
	}

	adminIcon(){
		return <div className={'admin-icon ' + (this.props.className || '')} onClick={this.handleClick} ref={(ele) => {console.log('Ref ele:', ele); this._ele = ele} } >
			<InitialsIcon name={this.account.fullName} className='account-icon round green' />
		</div>;
	}

	render(){
		return(
			<Popup trigger={this.adminIcon()} position='right bottom' on='click' hideOnScroll flowing>
				<div className='account-icon-popup'>
					<div className='table align-middle'>
						<div>
							<div><InitialsIcon name={this.account.fullName} className='account-icon round green' /></div>
							<div>
								<div className='wn'>
									<span className='welcome'>Welcome,<br/></span>
									<span className='name'>{this.account.fullName}</span>
								</div>
							</div>
						</div>
					</div>
					<Button className='logout' caption='Logout' onClick={() => {window.logout()}} />
				</div>
			</Popup>
		)
	}
}


// WEBPACK FOOTER //
// ./src/views/AdminIcon.js